export const eventFormSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'eventForm']);
export const eventFormListSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'eventFormList']);
export const dataObjectsSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'dataObjects']);
export const eventGroupsSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'eventGroups']);
export const eventFormTagsSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'formTags']);
export const eventFormPublishedTypesSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'publishedTypes']);
export const eventFormUnPublishedTypesSelector = state =>
  state.getIn(['app', 'events', 'eventform', 'unPublishedTypes']);
export const formFieldFormSelector = state =>
  state.getIn(['form', 'formField']);
